import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import styles from '../../styles'
import { FormattedMessageModel } from './types/fieldsModel'
import { makeStyles } from 'tss-react/mui'
import { styled, TextField } from '@mui/material'

interface CustomTextFieldProps {
	hasvalue: boolean
}

const CustomTextField = styled(TextField)<CustomTextFieldProps>(({ theme, hasvalue }) => ({
	'& .MuiInputLabel-shrink': {
		color: theme.palette.blue.main
	},
	'& label.Mui-focused': {
		color: theme.palette.blue.main
	},
	'& .MuiInputBase-formControl': {
		...styles(theme).text1,
		fontSize: 15,
		color: hasvalue ? theme.palette.blue.main : '#D9D9D9',
		border: `1px solid ${hasvalue ? theme.palette.blue.main : '#D9D9D9'}`,
		fontWeight: 500,
		lineHeight: 1.33,
		borderRadius: 23,
		marginTop: 5,
		padding: '12px 12px 12px 16px'
	},

	'& .MuiTypography-root': {
		color: hasvalue ? theme.palette.blue.main : '#8895a1'
	},

	'& .MuiOutlinedInput-root': {
		'& .MuiOutlinedInput-notchedOutline': {
			border: 'none'
		}
	}
}))

const useStyles = makeStyles()(
	(theme) => (
		{
			...styles(theme),
			textFieldStyle: {
				width: '100%',
				boxSizing: 'border-box',

				'& label': {
					marginBottom: 5,
					...styles(theme).text7,
					fontSize: 11
				},

				'& input': {
					padding: 0
				}
			},
			errorStyle: {
				color: '#B92D00',
				fontSize: '10px'
			},
			errorBorder: {
				border: '1px solid #B92D00'
			},
			disabledStyle: {
				'& input': {
					opacity: '0.7 !important'
				}
			},
			textFontSize: {
				fontSize: 16
			},
			defaultTextFieldContainerStyle: {
				width: '100%'
			}
		}
	)
)

interface AcceptingProps {
	id: string,
	label?: string,
	placeholder?: FormattedMessageModel,
	maxLength?: number,
	disabled?: boolean,
	multiline?: boolean,
	textFieldContainerStyle?: string,
	readonly?: boolean
}

type FormTextFieldInlineProps =
	FieldRenderProps<string>
	& AcceptingProps

const FormTextFieldInline: React.FC<FormTextFieldInlineProps> = (
	{
		input,
		meta: {
			touched,
			error
		},
		id,
		label,
		maxLength,
		disabled,
		multiline,
		textFieldContainerStyle,
		readonly
	}
) => {
	const { classes, cx } = useStyles()

	const textFieldClass = cx(
		classes.textFieldStyle,
		{
			[classes.errorBorder]: touched && error,
			[classes.disabledStyle]: disabled
		}
	)

	const checkKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === '"') {
			e.preventDefault()
		}
	}

	return (
		<div
			className={
				cx(
					classes.defaultTextFieldContainerStyle,
					textFieldContainerStyle
				)
			}
		>
			<CustomTextField
				id={id}
				onKeyDown={checkKeyDown}
				disabled={disabled}
				label={label}
				InputLabelProps={{
					shrink: true
				}}
				InputProps={{
					disableUnderline: true,
					readOnly: readonly
				}}
				className={textFieldClass}
				multiline={multiline}
				inputProps={{ maxLength: maxLength }}
				hasvalue={!!input.value && input.value.toString().length > 0}
				{...input}
			/>

			{touched && error && <span className={classes.errorStyle}>{error}</span>}
		</div>
	)
}

export default FormTextFieldInline
